var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClosePrompt,
          expression: "onClosePrompt",
        },
      ],
      staticClass: "prompt-container",
    },
    [
      _c("div", { staticClass: "prompt-header" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "div",
        { staticClass: "prompt-body" },
        [
          _vm._t("default"),
          _vm.warning
            ? _c("div", { staticClass: "warning-container" }, [
                _c("div", { staticClass: "warning-title" }, [
                  _vm._v(_vm._s(_vm.$t("camstudy.promptModal.warningTitle"))),
                ]),
                _c("div", { staticClass: "warning-message" }, [
                  _vm._v(_vm._s(_vm.$t("camstudy.promptModal.warningMessage"))),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "select-footer" }, [
        _c(
          "button",
          {
            staticClass: "select-footer-button select-cancel",
            on: { click: _vm.onClosePrompt },
          },
          [_vm._v(_vm._s(_vm.button[0]))]
        ),
        _c(
          "button",
          {
            staticClass: "select-footer-button select-save",
            on: { click: _vm.onNextAct },
          },
          [_vm._v(_vm._s(_vm.button[1]))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }